import React, { Component } from "react";
import {
  DKLabel,
  DKButton,
  DKInput,
  INPUT_TYPE,
  INPUT_VIEW_DIRECTION,
  showAlert,
} from "deskera-ui-library";

import thumbnail_THANK_1 from "../../assets/thankYouTemplate/template_0.png";
import thumbnail_THANK_2 from "../../assets/thankYouTemplate/template_0.png";
import thumbnail_THANK_3 from "../../assets/thankYouTemplate/template_0.png";

import FunnelManager from "./FunnelManager";

import TemplateManager_LP from "../landing_pages/templates/TemplateManager";
import TemplateManager_Form from "../forms/templates/TemplateManager";
import ThankYouTemplateManager from "./templates/ThankYouTemplateManager";

import { PAGE_TYPE } from "../page_designer/ComponentList";
import LandingPageManager from "../landing_pages/LandingPageManager";
import FormManager from "../forms/FormManager";

/*
PROPS:
- data (step / page data)
*/

class NewPagePopup extends Component {
  //////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////

  constructor(props) {
    super(props);
    this.state = {
      title: this.props.data ? this.props.data.title : "New Page",
      path: this.props.data
        ? this.props.data.path
        : "/step" + (FunnelManager.getCurrentFunnelData().length + 1),
      templateData: this.props.data ? this.props.data.templateData : null,
      templateIndex: null,
      selectedTemplatePageType: this.props.data
        ? this.props.data.pageType
        : null,
      pageType: this.props.data
        ? this.props.data.pageType
        : PAGE_TYPE.PEOPLE_EMAIL_TEMPLATE,
      canValidate: false,
    };
  }

  //////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////

  render() {
    return (
      <div className="transparent-background">
        <div className="popup-window" style={{ padding: 26, minWidth: 650 }}>
          {this.getHeader()}
          {this.getForm()}
          {this.getTemplateTypeSelection()}
          <div
            className="row flex-wrap mt-l pb-m align-items-start"
            style={{ gap: 20, minHeight: 445 }}
          >
            {this.getAllTemplates()}
          </div>
        </div>
      </div>
    );
  }

  //////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////

  getForm() {
    return (
      <div className="parent-width  ">
        <DKInput
          title="Name"
          type={INPUT_TYPE.TEXT}
          value={this.state.title}
          direction={INPUT_VIEW_DIRECTION.VERTICAL}
          required
          canValidate={this.state.canValidate}
          onChange={(value) => {
            this.setState({ title: value });
          }}
          className="mt-l"
        />
        <DKInput
          title="Webpage path"
          type={"URL"}
          value={this.state.path}
          direction={INPUT_VIEW_DIRECTION.VERTICAL}
          required
          canValidate={this.state.canValidate}
          onChange={(value) => {
            this.setState({ path: value });
          }}
          className="mt-r"
        />
      </div>
    );
  }

  //////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////

  getHeader() {
    return (
      <div className="row justify-content-between align-items-start">
        <div>
          <DKLabel
            text={this.props.data ? "Edit page details" : "+ New Page"}
            className="fw-m fs-l"
          />
          <DKLabel
            text={
              this.props.data
                ? "Update page title, path and template design"
                : "Create a new step/page to this funnel"
            }
            className="text-gray mt-xs"
          />
        </div>
        <div className="row" style={{ width: "auto" }}>
          <DKButton
            title="Cancel"
            className="bg-gray1 border-m ml-xxl"
            onClick={() => {
              this.props.onCancel();
            }}
          />
          <DKButton
            title="Save"
            className="bg-app text-white border-m ml-r"
            onClick={() => {
              if (this.state.path.includes(" ")) {
                showAlert(
                  "Invalid Path",
                  "Webpage path can't have any spaces, *, &, @, # or any special character."
                );
              } else if (
                this.state.title.trim() === "" ||
                this.state.path.trim() === ""
              ) {
                this.setState({ canValidate: true });
              } else if (this.state.templateData === null) {
                showAlert(
                  "Select template",
                  "Please select a template for page to proceed."
                );
              } else if (
                !FunnelManager.isStepPathAvailable(
                  this.state.path,
                  this.props.data ? this.props.data.path : undefined
                )
              ) {
                showAlert(
                  "Path unavailable!",
                  "Webpage path is already in use with some other page of this funnel.<br/><br/>Webpage path should be unique."
                );
              } else {
                let path = this.state.path;
                if (path.charAt(0) !== "/") {
                  path = "/" + path;
                }
                this.props.onSave({
                  title: this.state.title,
                  path: path,
                  pageType: this.state.selectedTemplatePageType,
                  templateData: this.state.templateData,
                });
              }
            }}
          />
        </div>
      </div>
    );
  }

  //////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////

  getTemplateData() {
    if (this.state.selectedTemplatePageType === PAGE_TYPE.PEOPLE_EMAIL_TEMPLATE) {
      return TemplateManager_LP.getTemplateData(this.state.templateIndex);
    } else if (this.state.selectedTemplatePageType === PAGE_TYPE.FORM) {
      return TemplateManager_Form.getTemplateData(this.state.templateIndex);
    } else if (
      this.state.selectedTemplatePageType === PAGE_TYPE.THANK_YOU_PAGE
    ) {
      return ThankYouTemplateManager.getTemplateData(this.state.templateIndex);
    }
  }

  getTemplateTypeSelection() {
    const selectedClass = "fw-b text-blue unselectable text-underline";
    const idleClass = " unselectable";
    return (
      <div
        className="row mt-xxl border-radius-r bg-gray2 p-h-xs text-gray"
        style={{ gap: 2, width: "auto" }}
      >
        <DKButton
          title="Landing Page"
          className={
            this.state.pageType === PAGE_TYPE.PEOPLE_EMAIL_TEMPLATE
              ? selectedClass
              : idleClass
          }
          onClick={() => {
            this.setState({ pageType: PAGE_TYPE.PEOPLE_EMAIL_TEMPLATE });
          }}
        />
        |
        <DKButton
          title="Contact Form"
          className={
            this.state.pageType === PAGE_TYPE.FORM ? selectedClass : idleClass
          }
          onClick={() => {
            this.setState({ pageType: PAGE_TYPE.FORM });
          }}
        />
        |
        <DKButton
          title="Thank you page"
          className={
            this.state.pageType === PAGE_TYPE.THANK_YOU_PAGE
              ? selectedClass
              : idleClass
          }
          onClick={() => {
            this.setState({ pageType: PAGE_TYPE.THANK_YOU_PAGE });
          }}
        />
      </div>
    );
  }

  ////////////////////////////////////////////////

  getLandingPageThumbnails() {
    return LandingPageManager.getAllTemplates();
  }
  getFormThumbnails() {
    return FormManager.getAllTemplates();
  }
  getThankYouThumbnails() {
    return [thumbnail_THANK_1, thumbnail_THANK_2, thumbnail_THANK_3];
  }

  ////////////////////////////////////////////////

  getAllTemplates() {
    let templates = [];
    if (this.state.pageType === PAGE_TYPE.PEOPLE_EMAIL_TEMPLATE) {
      templates = this.getLandingPageThumbnails();
    } else if (this.state.pageType === PAGE_TYPE.FORM) {
      templates = this.getFormThumbnails();
    } else if (this.state.pageType === PAGE_TYPE.THANK_YOU_PAGE) {
      templates = this.getThankYouThumbnails();
    }

    return templates.map((img, index) => {
      return (
        <div
          className={
            "cursor-hand " +
            (this.state.templateIndex === index &&
            this.state.selectedTemplatePageType === this.state.pageType
              ? "border-blue p-s border-box"
              : "border-m")
          }
          style={{ width: 130 }}
          onClick={() => {
            this.setState(
              {
                templateIndex: index,
                selectedTemplatePageType: this.state.pageType,
              },
              () => {
                this.setState({ templateData: this.getTemplateData() });
              }
            );
          }}
        >
          <img src={img} alt="" className="parent-width" />
        </div>
      );
    });
  }

  //////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////
}

export default NewPagePopup;
